"use client";

import dynamic from "next/dynamic";

export const MusicAPIWrapper = dynamic(() => import("./MusicAPI").then(mod => mod.MusicAPI));
